"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MalomoText = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
const config_2 = require("assets/styles/config");
// (HTMLProps<'span'> | HTMLProps<'p'> | HTMLProps<'label'>) & {
//   className?: string;
//   bold: boolean;
//   children: React.ReactNode;
//   fontSize: string;
//   gray?: boolean;
//   label?: boolean;
//   paragraph?: boolean;
//   small?: boolean;
//   uppercaseLabel?: boolean;
// };
const Default = styled_components_1.default.span `
  font-family: ${config_1.fontFamilies.primary};
`;
const UppercaseLabel = styled_components_1.default.span `
  font-family: ${config_1.fontFamilies.primary};
  text-transform: uppercase;
  font-weight: ${(props) => props.bold && 'bold'};
  font-size: ${(props) => props.fontSize};
`;
const Label = styled_components_1.default.label `
  font-family: ${config_1.fontFamilies.primary};
  font-size: 15px;
`;
const Paragraph = styled_components_1.default.p `
  color: ${(props) => props.gray && config_1.colors.thundercloud};
  font-family: ${config_1.fontFamilies.primary};
  font-weight: ${(props) => props.bold && 'bold'};
  font-size: ${(props) => (props.small ? config_2.fontSizes.small : '')};
  line-height: 28px;
`;
const MalomoText = (_a) => {
    var { children, label, uppercaseLabel, paragraph } = _a, rest = __rest(_a, ["children", "label", "uppercaseLabel", "paragraph"]);
    if (uppercaseLabel) {
        return react_1.default.createElement(UppercaseLabel, Object.assign({}, rest), children);
    }
    if (label) {
        return react_1.default.createElement(Label, Object.assign({}, rest), children);
    }
    if (paragraph) {
        return react_1.default.createElement(Paragraph, Object.assign({}, rest), children);
    }
    return react_1.default.createElement(Default, Object.assign({}, rest), children);
};
exports.MalomoText = MalomoText;
